import styled from "styled-components"

export const BVASelectContainer = styled.div`
    .MuiInputBase-root {
        max-width: 100%;
    }
    
    .bva-select {
     width: 100%;
     min-width: ${props => props.width ? props.width : "10em"};
     max-width: ${props => props.width ? props.width : "10em"};
    }
`
